
interface CardButtonProps {
  className?: string;
}

export const Exchange = ({ className }: CardButtonProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38048 7.28033C9.67337 6.98744 9.67337 6.51256 9.38048 6.21967C9.08758 5.92678 8.61271 5.92678 8.31982 6.21967L6.21967 8.31982C5.92678 8.61271 5.92678 9.08758 6.21967 9.38048L8.31982 11.4806C8.61271 11.7735 9.08758 11.7735 9.38048 11.4806C9.67337 11.1877 9.67337 10.7129 9.38048 10.42L8.56066 9.60015H17.2507C17.6649 9.60015 18.0007 9.26436 18.0007 8.85015C18.0007 8.43593 17.6649 8.10015 17.2507 8.10015H8.56066L9.38048 7.28033ZM15.6809 12.5201C15.388 12.2272 14.9131 12.2272 14.6203 12.5201C14.3274 12.813 14.3274 13.2879 14.6203 13.5808L15.4401 14.4006H6.75C6.33579 14.4006 6 14.7364 6 15.1506C6 15.5648 6.33579 15.9006 6.75 15.9006H15.4401L14.6203 16.7204C14.3274 17.0133 14.3274 17.4882 14.6203 17.7811C14.9131 18.074 15.388 18.074 15.6809 17.7811L17.7811 15.6809C18.074 15.388 18.074 14.9132 17.7811 14.6203L15.6809 12.5201Z"
        fill="white"
      />
    </svg>
  );
};

export const Lightning = ({ className }: CardButtonProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.7897 11.5107C16.7748 11.4462 16.7442 11.3864 16.7006 11.3367C16.657 11.287 16.6017 11.2488 16.5397 11.2257L13.66 10.1458L14.3899 6.48122C14.4067 6.39633 14.3959 6.3083 14.359 6.23003C14.3221 6.15175 14.2611 6.08735 14.1849 6.04626C14.108 6.00536 14.0198 5.99102 13.9339 6.00549C13.848 6.01995 13.7693 6.06241 13.71 6.12626L8.11059 12.1256C8.0647 12.1732 8.03151 12.2316 8.01404 12.2953C7.99657 12.3591 7.99538 12.4262 8.0106 12.4906C8.02625 12.5547 8.05715 12.6141 8.10067 12.6637C8.14419 12.7133 8.19904 12.7517 8.26057 12.7756L11.1403 13.8554L10.4103 17.52C10.3936 17.6049 10.4044 17.693 10.4413 17.7712C10.4782 17.8495 10.5392 17.9139 10.6153 17.955C10.6727 17.984 10.736 17.9994 10.8003 18C10.8546 18.0002 10.9084 17.9892 10.9583 17.9677C11.0082 17.9462 11.0531 17.9147 11.0903 17.875L16.6897 11.8756C16.7356 11.828 16.7688 11.7697 16.7862 11.7059C16.8037 11.6422 16.8049 11.575 16.7897 11.5107Z"
        fill="white"
      />
    </svg>
  );
};

export const Bell = ({ className }: CardButtonProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8762 10.9209C8.8762 8.93337 10.1272 7.34443 12.0222 7.35455C13.9002 7.36919 15.1241 8.96922 15.1241 10.9209C15.1241 12.5757 15.4061 13.7157 15.7445 14.4873H13.7284C13.7278 14.4873 13.7273 14.4873 13.7267 14.4873C13.7261 14.4873 13.7255 14.4873 13.725 14.4873H10.2753C10.2747 14.4873 10.2742 14.4873 10.2736 14.4873C10.273 14.4873 10.2725 14.4873 10.2719 14.4873H8.25578C8.59419 13.7157 8.8762 12.5757 8.8762 10.9209ZM9.54414 15.9873H7.73773L7.73509 15.9873C7.52803 15.9865 7.32479 15.9314 7.14573 15.8274C6.96668 15.7234 6.8181 15.5741 6.71489 15.3946C6.61167 15.2151 6.55743 15.0116 6.55762 14.8046C6.5578 14.5975 6.61239 14.3941 6.71593 14.2148L6.71638 14.214C6.99457 13.7335 7.3762 12.7462 7.3762 10.9209C7.3762 8.36092 9.06645 5.83808 12.0313 5.85457L12.0328 5.85458C14.9779 5.87689 16.6241 8.41075 16.6241 10.9209C16.6241 12.7462 17.0057 13.7335 17.2839 14.214L17.2843 14.2148C17.3879 14.3941 17.4425 14.5975 17.4426 14.8046C17.4428 15.0117 17.3886 15.2151 17.2854 15.3946C17.1822 15.5741 17.0336 15.7234 16.8545 15.8274C16.6755 15.9314 16.4722 15.9865 16.2652 15.9873L16.2625 15.9873H14.4561C14.3862 16.5266 14.1401 17.0313 13.7513 17.4201C13.2869 17.8845 12.657 18.1454 12.0001 18.1454C11.3433 18.1454 10.7134 17.8845 10.249 17.4201C9.86021 17.0313 9.61405 16.5266 9.54414 15.9873ZM11.077 15.9873C11.1248 16.1261 11.2038 16.2536 11.3096 16.3594C11.4928 16.5425 11.7411 16.6454 12.0001 16.6454C12.2591 16.6454 12.5075 16.5425 12.6907 16.3594C12.7964 16.2536 12.8755 16.1261 12.9233 15.9873H11.077Z"
        fill="white"
      />
    </svg>
  );
};

export const Bots = ({ className }: CardButtonProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8421 6.47368C13.8421 7.09216 13.4612 7.62163 12.9211 7.84024V9.42105H16.0526C17.2735 9.42105 18.2632 10.4107 18.2632 11.6316V13.6579H18.6316V12.9211C18.6316 12.6159 18.879 12.3684 19.1842 12.3684C19.4894 12.3684 19.7368 12.6159 19.7368 12.9211V15.5C19.7368 15.8052 19.4894 16.0526 19.1842 16.0526C18.879 16.0526 18.6316 15.8052 18.6316 15.5V14.7632H18.2632V16.7895C18.2632 18.0103 17.2735 19 16.0526 19H8.68421C7.46337 19 6.47368 18.0103 6.47368 16.7895V14.7632H6.10526V15.5C6.10526 15.8052 5.85782 16.0526 5.55263 16.0526C5.24744 16.0526 5 15.8052 5 15.5V12.9211C5 12.6159 5.24744 12.3684 5.55263 12.3684C5.85782 12.3684 6.10526 12.6159 6.10526 12.9211V13.6579H6.47368V11.6316C6.47368 10.4107 7.46337 9.42105 8.68421 9.42105H11.8158V7.84024C11.2757 7.62163 10.8947 7.09216 10.8947 6.47368C10.8947 5.6598 11.5545 5 12.3684 5C13.1823 5 13.8421 5.6598 13.8421 6.47368ZM10.7105 15.6842C10.4053 15.6842 10.1579 15.9317 10.1579 16.2368C10.1579 16.542 10.4053 16.7895 10.7105 16.7895H14.0263C14.3315 16.7895 14.5789 16.542 14.5789 16.2368C14.5789 15.9317 14.3315 15.6842 14.0263 15.6842H10.7105ZM10.1579 14.5789C10.9718 14.5789 11.6316 13.9191 11.6316 13.1053C11.6316 12.2914 10.9718 11.6316 10.1579 11.6316C9.34397 11.6316 8.68421 12.2914 8.68421 13.1053C8.68421 13.9191 9.34397 14.5789 10.1579 14.5789ZM16.0526 13.1053C16.0526 13.9191 15.3929 14.5789 14.5789 14.5789C13.765 14.5789 13.1053 13.9191 13.1053 13.1053C13.1053 12.2914 13.765 11.6316 14.5789 11.6316C15.3929 11.6316 16.0526 12.2914 16.0526 13.1053Z"
        fill="white"
      />
    </svg>
  );
};
